import Api from "../../config/ApiConfig";
import {  IGetProfileParams, IProfile } from "./types";

const apiUrls = {getUsers: "api/v1/users"}

export const getProfile = (params: IGetProfileParams) =>
    params.adGroup ? Api.get<IProfile[]>(apiUrls.getUsers + "?adgroup=" + params.adGroup) : Api.get<IProfile[]>(apiUrls.getUsers + "?userName=" + params.userName) ;